import { render, staticRenderFns } from "./info_kind.vue?vue&type=template&id=e71d87ee&scoped=true&"
import script from "./info_kind.vue?vue&type=script&lang=js&"
export * from "./info_kind.vue?vue&type=script&lang=js&"
import style0 from "./info_kind.vue?vue&type=style&index=0&id=e71d87ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/registry.npmjs.org/vue-loader/15.8.3_25647bdc581bdda9c9b762adc3f55a51/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e71d87ee",
  null
  
)

export default component.exports